import React, { Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { FormattedMessageWithClass } from '../commonComponents';
import './cookiePolicy.scss';

const CookiePolicyFooter = ({history}) => {

  const redirectTo = () => {
    history.push('cookie-policy');
  };

  return (
    <Fragment>
      <div className="cookie-policy-footer-wrapper">
        <div className="cookie-policy-footer-inner">
          <span id='ot-sdk-btn' className='ot-sdk-show-settings nolink'>Cookie Settings</span>
          <figure onClick={() => redirectTo()}>
            <FormattedMessageWithClass
              className='cookie-policy-footer'
              id='cookie_policy.cookie_policy_footer'
              defaultMessage="Cookie Policy"
            />
          </figure>
        </div>
      </div>
    </Fragment>
  );
};

export default withRouter(CookiePolicyFooter);
